<div *ngIf="!this.loadingService.isLoading" class="contentGlobal">
    <div style="display: flex; align-items: stretch; flex-flow: row wrap; margin: 0.8rem">
        <mat-card class="fuse-card-medium industriesCard" *ngFor="let industry of industryDictionaryList">
            <mat-card-title style="text-align: center">
                <img [src]="industry.ProductID == 'MW' ? 'assets/MW_b.png' : 'assets/MAGOCLOUD-logo.png'" style="max-width: 200px" /><br />
                <div style="margin-top: 1.2rem">{{ industry.TranslatedName }}</div>
            </mat-card-title>

            <mat-card-actions>
                <button
                    mat-fab
                    color="primary"
                    routerLinkActive="router-link-active "
                    (click)="isAuthenticated(industry.ProductID, industry.ModuleCode, industry.Versioning)"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </mat-card-actions>
            <mat-card-content class="fuse-card-contentSmall">
                <div [innerHtml]="industry.Description"></div>
                <a
                    *ngIf="industry.ProductID != 'MW'"
                    matTooltip="{{ 'COMMONS.OPENFILEPDF' | translate }}"
                    target="_blank "
                    class="cursorHand"
                    matTooltipClass="tooltip-layout"
                    matTooltipPosition="above"
                    (click)="openPdfIndustry(industry)"
                >
                    <span translate>INDUSTRY_CONFIGURATOR.COMPAREFEATURES</span>
                </a>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div class="container" *ngIf="this.loadingService.isLoading">
    <tb-loading></tb-loading>
</div>
